import React from 'react';

// Stroke uses currentColor, so set `color` in CSS to recolour the icon.
const Chevron = ({ d, className }) => (
	<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d={d} />
	</svg>
);

export const ChevronLeftIcon = (props) => <Chevron d="M15 18l-6-6 6-6" {...props} />;
export const ChevronRightIcon = (props) => <Chevron d="M9 18l6-6-6-6" {...props} />;

// Filled circle with a diamond cut-out; fill uses currentColor so `color` in CSS recolours it.
export const PointsIcon = ({ className }) => (
	<svg className={className} viewBox="0 0 24 24" aria-hidden="true">
		<circle cx="12" cy="12" r="12" fill="currentColor" />
		<path d="M12 5l7 7-7 7-7-7z" fill="#FFF" />
		<path d="M12 9l3 3-3 3-3-3z" fill="currentColor" />
	</svg>
);

// Line icons for the tools cards; stroke uses currentColor like Chevron.
const LineIcon = ({ className, children }) => (
	<svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		{children}
	</svg>
);

export const PosterIcon = (props) => (
	<LineIcon {...props}>
		<rect x="3" y="3" width="18" height="18" rx="4" />
		<path d="M11 3v8H3" />
		<path d="M11 11l3 10" />
	</LineIcon>
);

export const VideoIcon = (props) => (
	<LineIcon {...props}>
		<rect x="2" y="6" width="14" height="12" rx="3" />
		<path d="M16 10.5l5-3v9l-5-3" />
		<circle cx="7" cy="10.5" r="1" />
	</LineIcon>
);

export const CouponIcon = (props) => (
	<LineIcon {...props}>
		<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
		<path d="M9 9h.01M15 15h.01M15 9l-6 6" />
	</LineIcon>
);

export const BellIcon = (props) => (
	<LineIcon {...props}>
		<path d="M6 8a6 6 0 0 1 12 0c0 4.5 1.4 6 2.7 7.3A1 1 0 0 1 20 17H4a1 1 0 0 1-.7-1.7C4.6 14 6 12.5 6 8" />
		<path d="M10.3 21a2 2 0 0 0 3.4 0" />
	</LineIcon>
);

export const ArrowRightIcon = (props) => (
	<LineIcon {...props}>
		<path d="M5 12h14M13 6l6 6-6 6" />
	</LineIcon>
);

// Filled bookmark with a star cut-out; fill uses currentColor.
export const RankIcon = ({ className }) => (
	<svg className={className} viewBox="0 0 24 24" aria-hidden="true">
		<path d="M6 2h12a1 1 0 0 1 1 1v18.2a.6.6 0 0 1-.95.5L12 17.5l-6.05 4.2a.6.6 0 0 1-.95-.5V3a1 1 0 0 1 1-1z" fill="currentColor" />
		<path d="M12 6l1.2 2.5 2.7.4-2 1.9.5 2.7-2.4-1.3-2.4 1.3.5-2.7-2-1.9 2.7-.4z" fill="#FFF" />
	</svg>
);

// Filled chat bubble with three dots; fill uses currentColor.
export const MessageIcon = ({ className }) => (
	<svg className={className} viewBox="0 0 24 24" aria-hidden="true">
		<path d="M6 3h12a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4h-4l-3 3.5a.6.6 0 0 1-1-.4V18H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z" fill="currentColor" />
		<circle cx="8" cy="10.5" r="1.2" fill="#FFF" />
		<circle cx="12" cy="10.5" r="1.2" fill="#FFF" />
		<circle cx="16" cy="10.5" r="1.2" fill="#FFF" />
	</svg>
);

// Filled rounded square with a trending-up arrow; fill uses currentColor.
export const TrendIcon = ({ className }) => (
	<svg className={className} viewBox="0 0 24 24" aria-hidden="true">
		<rect width="24" height="24" rx="6" fill="currentColor" />
		<path d="M6 16.5l4.5-4.5 3 3L18 10.5M14 10.5h4v4" fill="none" stroke="#FFF" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

// Discount seal with a % cut-out (evenodd), so the badge background shows through; fill uses currentColor.
export const DiscountIcon = ({ className }) => (
	<svg className={className} viewBox="0 0 24 24" aria-hidden="true">
		<path fillRule="evenodd" fill="currentColor" d="M12.0 1.0L15.6 3.4L19.8 4.2L20.6 8.4L23.0 12.0L20.6 15.6L19.8 19.8L15.6 20.6L12.0 23.0L8.4 20.6L4.2 19.8L3.4 15.6L1.0 12.0L3.4 8.4L4.2 4.2L8.4 3.4zM8 9.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0zM13 14.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0zM15.2 7.8l1 1-7.4 7.4-1-1z" />
	</svg>
);
export const MedalIcon = ({ className }) => (
	<svg className={className} viewBox="0 0 24 24" aria-hidden="true">
		<path fill="currentColor" d="M7.6 13.6L5.6 21l3.1-1.1 1.8 2.6 1.3-6.6zM16.4 13.6l2 7.4-3.1-1.1-1.8 2.6-1.3-6.6z" />
		<path fillRule="evenodd" fill="currentColor" d="M12 2a7 7 0 1 1 0 14a7 7 0 1 1 0-14zM12.00 5.40L12.88 7.79L15.42 7.89L13.43 9.46L14.12 11.91L12.00 10.50L9.88 11.91L10.57 9.46L8.58 7.89L11.12 7.79z" />
	</svg>
);
